export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7056704d1ddc9df4384364c9879d3cff20a713bcc8&name=pushAdClickData!'